import { ActionButton } from '@appcharge/shared-ui';
import { t } from 'i18next';
import { usePopupState } from 'state/hooks/popup.state.hook';
import { StyledPopupHandlerFailScreen } from './style';

export const PopupFailScreen: React.FC = () => {
  const { setShowFailPopup, showFailPopup } = usePopupState();

  const onTryAgain = () => {
    setShowFailPopup(false);
    window.location.reload();
  };

  if (!showFailPopup) return null;

  return (
    <StyledPopupHandlerFailScreen className="popup-fail-screen">
      <h2>{t ? t('failed.somethingWentWrong') : 'Something went wrong'}</h2>
      <ActionButton
        className={'action-button'}
        borderRadius={'7px'}
        text={'Try Again'}
        action={onTryAgain}
      ></ActionButton>
    </StyledPopupHandlerFailScreen>
  );
};
